import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { TextSizeMap } from '../../../shared/constants/text-size-map.constant';
import { NgTextDirective } from '../../../shared/directives/ng-text.directive';
import { NzMessageService } from 'ng-zorro-antd/message';
import { firstValueFrom } from 'rxjs';
import { NewsLetterSubscriptionAPIService } from '../../../shared/apiservices/newslettersubscription-api.service';
import { EMPTY_GUID } from '../../../shared/utils/helpers.util';

@Component({
  selector: 'app-newsletter',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    NzButtonModule,
    CommonModule,
    NgTextDirective,
  ],
  templateUrl: './newsletter.component.html',
})
export class NewsletterComponent {
  newsletterForm!: FormGroup;
  TextSizeMap = TextSizeMap;
  isAPICallSent = signal(false);
  newsLetterSubscriptionAPIService = inject(NewsLetterSubscriptionAPIService);

  constructor(private fb: FormBuilder, private message: NzMessageService) {
    this.newsletterForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  async submit(): Promise<void> {
    if (this.newsletterForm.valid) {
      console.log('Subscribed with:', this.newsletterForm.value.email);
      // TODO: call your API here
      try {

        this.isAPICallSent.set(true);
        await firstValueFrom(this.newsLetterSubscriptionAPIService.AddNewsLetterSubscriptionData({
          id: EMPTY_GUID,
          email: this.newsletterForm.value.email,
          subscribedOn: new Date()
        }));
        this.message.success("Subscribed Successfully!");
      } catch (err) {

      } finally {
        this.isAPICallSent.set(false)
      }

      this.newsletterForm.reset();
    }
  }
}
